import {useRef} from 'react'

export const useMax = (i?: number) => {
  const ref = useRef<number>()
  if (i !== undefined && i >= (ref.current ?? -Infinity)) {
    ref.current = i
  }
  return ref.current
}
